import { jsx } from 'react/jsx-runtime';

const CarouselStep = ({ children, inactive = false })=>{
    if (inactive) {
        return null;
    }
    return jsx("div", {
        className: "cb-carousel-step",
        children: children
    });
};
CarouselStep.displayName = 'Carousel.Step';

export { CarouselStep };
//# sourceMappingURL=Carousel.Step.es.js.map
